import React, { useEffect, useState } from "react";
import { Icon, initialsOf } from "./icons";
import "./ManageServices.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const STATUS_META = {
  pending: { label: "प्रलंबित", cls: "gp-badge-amber", dot: "#E58A00" },
  approved: { label: "मंजूर", cls: "gp-badge-green", dot: "#2E7D32" },
  rejected: { label: "नाकारले", cls: "gp-badge-red", dot: "#D6452B" },
};

const ManageServices = () => {
  const [applications, setApplications] = useState([]);
  const [activeFilter, setActiveFilter] = useState("pending");

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // approved | rejected
  const [message, setMessage] = useState("");
  const [selectedAppId, setSelectedAppId] = useState(null);

  const token = localStorage.getItem("token");

  /* ================= FETCH ================= */
  const fetchApplications = async () => {
    const res = await fetch(`${API}/api/admin/services`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    setApplications(Array.isArray(data) ? data : []);
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  /* ================= OPEN MODAL ================= */
  const openModal = (id, type) => {
    setSelectedAppId(id);
    setModalType(type);
    setMessage("");
    setShowModal(true);
  };

  /* ================= CONFIRM ================= */
  const confirmAction = async () => {
    if (!message.trim()) {
      alert("संदेश आवश्यक आहे");
      return;
    }

    try {
      await fetch(`${API}/api/admin/services/${selectedAppId}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          status: modalType === "approved" ? "Approved" : "Rejected",
          adminRemark: message,
        }),
      });

      setShowModal(false);
      setSelectedAppId(null);
      setMessage("");
      fetchApplications();
    } catch (err) {
      alert("अर्ज अद्ययावत करता आला नाही ❌");
    }
  };

  /* ================= FILTER (FIXED) ================= */
  const filteredApps = applications.filter(
    (a) => a.status?.toLowerCase() === activeFilter
  );

  const count = (status) =>
    applications.filter((a) => a.status?.toLowerCase() === status).length;

  return (
    <div className="admin-page admin-page--narrow">
      <div className="gp-page-head">
        <div>
          <h1>सेवा अर्ज व्यवस्थापन</h1>
          <p>नागरिकांचे सेवा अर्ज तपासा, मंजूर करा किंवा नाकारा</p>
        </div>
      </div>

      {/* FILTER TABS */}
      <div className="svc-tabs">
        <button
          className={`gp-tab ${activeFilter === "pending" ? "active" : ""}`}
          onClick={() => setActiveFilter("pending")}
        >
          <span className="gp-tab-dot" style={{ background: "#E58A00" }} />
          प्रलंबित <span style={{ opacity: 0.7 }}>({count("pending")})</span>
        </button>

        <button
          className={`gp-tab ${activeFilter === "approved" ? "active" : ""}`}
          onClick={() => setActiveFilter("approved")}
        >
          <span className="gp-tab-dot" style={{ background: "#2E7D32" }} />
          मंजूर <span style={{ opacity: 0.7 }}>({count("approved")})</span>
        </button>

        <button
          className={`gp-tab ${activeFilter === "rejected" ? "active" : ""}`}
          onClick={() => setActiveFilter("rejected")}
        >
          <span className="gp-tab-dot" style={{ background: "#D6452B" }} />
          नाकारलेले <span style={{ opacity: 0.7 }}>({count("rejected")})</span>
        </button>
      </div>

      {/* LIST */}
      <div className="svc-list">
        {filteredApps.length === 0 && (
          <div className="gp-empty">या श्रेणीमध्ये कोणतेही अर्ज नाहीत</div>
        )}

        {filteredApps.map((app) => {
          const meta = STATUS_META[app.status?.toLowerCase()] || STATUS_META.pending;
          return (
            <div className="gp-card svc-card" key={app._id}>
              <div className="svc-row">
                <div className="gp-avatar">{initialsOf(app.fullName)}</div>

                <div className="svc-main">
                  <div className="svc-name-row">
                    <h3>{app.fullName}</h3>
                    <span className={`gp-badge ${meta.cls}`}>{meta.label}</span>
                  </div>

                  <div className="svc-meta-row">
                    <div className="svc-meta-item">
                      <span>सेवा</span>
                      <b>{app.serviceType}</b>
                    </div>
                    <div className="svc-meta-item">
                      <span>मोबाईल</span>
                      <b>{app.mobile}</b>
                    </div>
                    {app.createdAt && (
                      <div className="svc-meta-item">
                        <span>अर्ज दिनांक</span>
                        <b>{new Date(app.createdAt).toLocaleDateString("en-GB")}</b>
                      </div>
                    )}
                  </div>

                  {app.documents && (
                    <div className="svc-docs">
                      {Object.entries(app.documents).map(([name, url], i) => (
                        <a key={i} href={url} target="_blank" rel="noreferrer" className="gp-attachment-link">
                          <Icon.attachment size={13} /> {name}
                        </a>
                      ))}
                    </div>
                  )}

                  {app.adminRemark && (
                    <div className="svc-remark">
                      <b>प्रशासकीय शेरा:</b> {app.adminRemark}
                    </div>
                  )}
                </div>

                {activeFilter === "pending" && (
                  <div className="svc-actions">
                    <button
                      className="gp-btn gp-btn-green gp-btn-sm"
                      onClick={() => openModal(app._id, "approved")}
                    >
                      <Icon.check size={14} /> मंजूर करा
                    </button>

                    <button
                      className="gp-btn gp-btn-danger-outline gp-btn-sm"
                      onClick={() => openModal(app._id, "rejected")}
                    >
                      <Icon.x size={14} /> नाकारा
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* POPUP */}
      {showModal && (
        <div className="gp-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="gp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="gp-modal-head">
              <h3>{modalType === "approved" ? "अर्ज मंजूर करा" : "अर्ज नाकारा"}</h3>
              <button className="gp-modal-close" onClick={() => setShowModal(false)}>
                <Icon.x size={15} />
              </button>
            </div>

            <textarea
              className="gp-textarea"
              placeholder={
                modalType === "approved"
                  ? "आपले दस्तऐवज तयार आहेत. आज दुपारी ४ वाजता पंचायत कार्यालयात या."
                  : "नाकारण्याचे कारण टाका"
              }
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <div className="gp-modal-actions">
              <button className="gp-btn gp-btn-blue" onClick={confirmAction}>
                पुष्टी करा
              </button>
              <button className="gp-btn gp-btn-ghost" onClick={() => setShowModal(false)}>
                रद्द करा
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageServices;
